import React from "react";

import {
  StyledMenu,
  StyledLink,
  StyledList,
  HeaderLink,
  HeaderNav,
  HeaderWrap,
  Container,
  HeaderText,
} from "./SideDrawer.style";

import Backdrop from "components/common/Backdrop";
import { ReactComponent as CloseIconAlt } from "assets/svgs/close-icon-alt.svg";
import { ReactComponent as ArrowLeft } from "assets/svgs/arrow-left.svg";

const SideDrawerWhoWeAre = ({ isOpen, close, closeSideDrawer }) => {
  const handleCloses = () => {
    close();
    closeSideDrawer();
  };
  return (
    <>
      <Backdrop
        show={isOpen}
        className="make-click"
        data-label="pano de fundo para fechar gaveta"
        onClick={close}
      />

      <StyledMenu isOpen={isOpen}>
        <HeaderNav onClick={close} header={true}>
          <HeaderWrap onClick={close}>
            <Container>
              <ArrowLeft />
              <HeaderText variant="body02-md" primaryColor={false}>
                Quem somos
              </HeaderText>
            </Container>
            <CloseIconAlt />
          </HeaderWrap>
        </HeaderNav>

        <StyledList>
          <StyledLink
            className="make-click"
            data-label="cnp-assurances mobile link"
            onClick={() => handleCloses()}
          >
            <HeaderLink width="100%" to="/cnp-assurances">
              <HeaderText variant="body02-md" color="primary-dark">
                CNP Assurances
              </HeaderText>
            </HeaderLink>
          </StyledLink>

          <StyledLink
            className="make-click"
            data-label="cnp-assurances mobile link"
            onClick={() => handleCloses()}
          >
            <HeaderLink width="100%" to="/cnp-seguros-holding-brasil">
              <HeaderText variant="body02-md" color="primary-dark">
                CNP Seguros Holding Brasil
              </HeaderText>
            </HeaderLink>
          </StyledLink>

          <StyledLink
            className="make-click"
            data-label="corpo-diretivo mobile link"
            onClick={() => handleCloses()}
          >
            <HeaderLink width="100%" to="/cultura-corporativa">
              <HeaderText variant="body02-md" color="primary-dark">
                Cultura Corporativa
              </HeaderText>
            </HeaderLink>
          </StyledLink>
        </StyledList>
      </StyledMenu>
    </>
  );
};

export default SideDrawerWhoWeAre;
